import { useEffect } from 'react';

function applyPolyfills() {
  if (!CanvasRenderingContext2D.prototype.roundRect) {
    CanvasRenderingContext2D.prototype.roundRect = function(x, y, w, h, r) {
      if (typeof r === 'number') r = [r, r, r, r];
      else if (r.length === 1) r = [r[0], r[0], r[0], r[0]];
      else if (r.length === 2) r = [r[0], r[1], r[0], r[1]];
      else if (r.length === 3) r = [r[0], r[1], r[2], r[1]];
      r = r.map(v => Math.min(v, Math.min(w / 2, h / 2)));
      this.moveTo(x + r[0], y);
      this.lineTo(x + w - r[1], y); this.arcTo(x + w, y, x + w, y + r[1], r[1]);
      this.lineTo(x + w, y + h - r[2]); this.arcTo(x + w, y + h, x + w - r[2], y + h, r[2]);
      this.lineTo(x + r[3], y + h); this.arcTo(x, y + h, x, y + h - r[3], r[3]);
      this.lineTo(x, y + r[0]); this.arcTo(x, y, x + r[0], y, r[0]);
      this.closePath(); return this;
    };
  }
}

export function useCanvasAnimations() {
  useEffect(() => {
    applyPolyfills();
    const script = document.createElement('script');
    script.id = 'sv-canvas-animations';
    script.setAttribute('data-speedvault', 'true');
    // Inline the animation code as a blob URL to avoid CSP issues
    const code = getAnimationCode();
    const blob = new Blob([code], { type: 'application/javascript' });
    const url = URL.createObjectURL(blob);
    script.src = url;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
      URL.revokeObjectURL(url);
    };
  }, []);
}

function getAnimationCode() {
  return animationCode;
}

export const animationCode = `

/* ── roundRect polyfill ── */
if(!CanvasRenderingContext2D.prototype.roundRect){
  CanvasRenderingContext2D.prototype.roundRect=function(x,y,w,h,r){
    if(typeof r==='number') r=[r,r,r,r];
    else if(r.length===1) r=[r[0],r[0],r[0],r[0]];
    else if(r.length===2) r=[r[0],r[1],r[0],r[1]];
    else if(r.length===3) r=[r[0],r[1],r[2],r[1]];
    r=r.map(function(v){return Math.min(v,Math.min(w/2,h/2));});
    this.moveTo(x+r[0],y);
    this.lineTo(x+w-r[1],y); this.arcTo(x+w,y,x+w,y+r[1],r[1]);
    this.lineTo(x+w,y+h-r[2]); this.arcTo(x+w,y+h,x+w-r[2],y+h,r[2]);
    this.lineTo(x+r[3],y+h); this.arcTo(x,y+h,x,y+h-r[3],r[3]);
    this.lineTo(x,y+r[0]); this.arcTo(x,y,x+r[0],y,r[0]);
    this.closePath(); return this;
  };
}


const EASE = t => t<.5 ? 2*t*t : -1+(4-2*t)*t;

/* ── NAV SCROLL ── */
const nav = document.getElementById('nav');
window.addEventListener('scroll', () => {
  nav.classList.toggle('scrolled', scrollY > 40);
  document.getElementById('backTop').classList.toggle('visible', scrollY > 400);
});

/* ── HAMBURGER ── */
const ham = document.getElementById('hamburger');
const drawer = document.getElementById('mobileDrawer');
ham.addEventListener('click', () => {
  ham.classList.toggle('open');
  drawer.classList.toggle('open');
  document.body.style.overflow = drawer.classList.contains('open') ? 'hidden' : '';
});
drawer.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
  ham.classList.remove('open'); drawer.classList.remove('open');
  document.body.style.overflow = '';
}));

/* ── BACK TO TOP ── */
document.getElementById('backTop').addEventListener('click', () => window.scrollTo({top:0,behavior:'smooth'}));

/* ── SCROLL REVEAL ── */
const revObs = new IntersectionObserver(entries => {
  entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('visible'); revObs.unobserve(e.target); }});
}, {threshold: 0.1});
document.querySelectorAll('.sol-block,.hiw-step,.ind-card,.why-card,.testi-card,.animate-on-scroll').forEach(el => revObs.observe(el));

/* ── ANIMATION TABS ── */
(function(){
  const tabs=document.querySelectorAll('.anim-tab');
  const panels=document.querySelectorAll('.anim-panel');
  if(!tabs.length) return;
  tabs.forEach(tab=>{
    tab.addEventListener('click',()=>{
      const i=parseInt(tab.dataset.tab);
      tabs.forEach(t=>t.classList.remove('active'));
      panels.forEach(p=>p.classList.remove('active'));
      tab.classList.add('active');
      panels[i].classList.add('active');
      // Delay resize so browser has time to compute layout after display:block
      setTimeout(()=>window.dispatchEvent(new Event('resize')), 30);
    });
  });
})();

/* ══════════════════════════════════════════════════════
   ANIM 1 — QR SCAN & PAY
══════════════════════════════════════════════════════ */
(function(){
  const c=document.getElementById('qrCanvas'); if(!c) return;
  const ctx=c.getContext('2d');
  let W,H; const dpr=window.devicePixelRatio||1;
  function resize(){var _w=c.offsetWidth||(c.parentElement&&c.parentElement.offsetWidth)||600,_h=c.offsetHeight||520;_w=_w<1?600:_w;_h=_h<1?520:_h;if(_w===W&&_h===H)return;W=_w;H=_h;c.width=W*dpr;c.height=H*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);}
  resize(); window.addEventListener('resize',resize);

  // Step sequencer
  const STEPS=5, SDUR=160; let fr=0, step=0;
  const sEls=document.querySelectorAll('#qrSteps .anim-step');

  // QR pattern (stable)
  const QP=[[1,1,1,1,1,1,1],[1,0,0,0,0,0,1],[1,0,1,1,1,0,1],[1,0,1,0,1,0,1],[1,0,1,1,1,0,1],[1,0,0,0,0,0,1],[1,1,1,1,1,1,1]];
  const innerC=[];
  for(let r=0;r<7;r++) for(let col=0;col<7;col++){
    if(!(r<3&&col<3)&&!(r<3&&col>3)&&!(r>3&&col<3)) if(Math.random()>.45) innerC.push([r,col]);
  }

  // Particles
  const parts=[];
  function burst(bx,by,n,cols){
    for(let i=0;i<n;i++){
      const a=Math.random()*Math.PI*2,s=2+Math.random()*5;
      parts.push({x:bx,y:by,vx:Math.cos(a)*s,vy:Math.sin(a)*s-1,a:1,r:2+Math.random()*3,col:cols[i%cols.length]});
    }
  }

  // Bezier helper
  function bz(t,x0,cx1,cx2,x1){const u=1-t;return u*u*u*x0+3*u*u*t*cx1+3*u*t*t*cx2+t*t*t*x1;}

  // TPS counter
  let tps=4820;
  setInterval(()=>{tps=Math.max(4100,Math.min(5800,tps+Math.round((Math.random()-.35)*90)));const el=document.getElementById('qrTps');if(el)el.textContent=tps.toLocaleString('en-IN');},1800);

  // Scan beam
  let beamY=0, bDir=2;

  function drawPhone(px,py,pw,ph,pr,step){
    // Drop shadow
    ctx.save(); ctx.shadowColor='rgba(0,100,200,.35)'; ctx.shadowBlur=40; ctx.shadowOffsetY=8;
    ctx.beginPath(); ctx.roundRect(px,py,pw,ph,pr); ctx.fillStyle='#141F35'; ctx.fill();
    ctx.restore();

    // Metal edge highlight
    const edgeG=ctx.createLinearGradient(px,py,px+pw,py+ph);
    edgeG.addColorStop(0,step>=4?'rgba(62,188,121,.7)':'rgba(0,153,214,.5)');
    edgeG.addColorStop(.5,'rgba(255,255,255,.08)');
    edgeG.addColorStop(1,step>=4?'rgba(62,188,121,.2)':'rgba(26,43,107,.3)');
    ctx.beginPath(); ctx.roundRect(px,py,pw,ph,pr);
    ctx.strokeStyle=edgeG; ctx.lineWidth=2.5; ctx.stroke();

    // Screen
    const sx=px+7,sy=py+16,sw=pw-14,sh=ph-30;
    ctx.beginPath(); ctx.roundRect(sx,sy,sw,sh,11); ctx.fillStyle='#0C1525'; ctx.fill();

    // Screen glare
    const gl=ctx.createLinearGradient(sx,sy,sx+sw*.7,sy+sh*.4);
    gl.addColorStop(0,'rgba(255,255,255,.06)'); gl.addColorStop(1,'transparent');
    ctx.beginPath(); ctx.roundRect(sx,sy,sw,sh,11); ctx.fillStyle=gl; ctx.fill();

    // Notch
    ctx.beginPath(); ctx.roundRect(px+pw*.28,py+6,pw*.44,12,6);
    ctx.fillStyle='#0A1020'; ctx.fill();
    // Camera lens
    ctx.beginPath(); ctx.arc(px+pw*.66,py+12,4,0,Math.PI*2);
    ctx.fillStyle='#0A1020'; ctx.fill();
    ctx.beginPath(); ctx.arc(px+pw*.66,py+12,2.5,0,Math.PI*2);
    ctx.fillStyle='#1A2840'; ctx.fill();
    ctx.beginPath(); ctx.arc(px+pw*.66+.8,py+11.2,1,0,Math.PI*2);
    ctx.fillStyle='rgba(255,255,255,.3)'; ctx.fill();

    // Status bar
    const ctrX=px+pw/2;
    ctx.font='bold 7px Nunito,sans-serif'; ctx.fillStyle='rgba(255,255,255,.4)';
    ctx.textAlign='left'; ctx.fillText('9:41',sx+8,sy+14);
    ctx.textAlign='right';
    // battery icon
    ctx.fillStyle='rgba(255,255,255,.35)';
    ctx.fillRect(sx+sw-24,sy+7,18,8); ctx.fillRect(sx+sw-6,sy+9,4,4);
    ctx.fillStyle='rgba(62,188,121,.8)'; ctx.fillRect(sx+sw-23,sy+8,12,6);

    // App bar
    const abG=ctx.createLinearGradient(sx,sy+16,sx,sy+40);
    abG.addColorStop(0,'rgba(0,153,214,.15)'); abG.addColorStop(1,'transparent');
    ctx.fillStyle=abG; ctx.fillRect(sx,sy+16,sw,28);
    ctx.font='bold 10px Nunito,sans-serif'; ctx.fillStyle='rgba(255,255,255,.88)';
    ctx.textAlign='center'; ctx.fillText('UPI Pay',ctrX,sy+32);

    // Back arrow
    ctx.font='9px sans-serif'; ctx.fillStyle='rgba(0,153,214,.7)';
    ctx.textAlign='left'; ctx.fillText('←',sx+8,sy+32);

    return {sx,sy,sw,sh,ctrX};
  }

  function draw(){
    ctx.clearRect(0,0,W,H);

    // Background with gradient and dots
    const bg=ctx.createRadialGradient(W*.4,H*.5,0,W*.5,H*.5,Math.max(W,H)*.75);
    bg.addColorStop(0,'#0C1A38'); bg.addColorStop(1,'#040A1A');
    ctx.fillStyle=bg; ctx.fillRect(0,0,W,H);

    // Animated dot grid
    for(let x=0;x<W;x+=40){
      for(let y=0;y<H;y+=40){
        const a=.04+.03*Math.sin((x+y)*.02+fr*.015);
        ctx.beginPath(); ctx.arc(x,y,1,0,Math.PI*2); ctx.fillStyle=\`rgba(0,153,214,\${a})\`; ctx.fill();
      }
    }

    // Phone dimensions - bigger
    const pw=148, ph=262, pr=22;
    const phoneX=W*.3-pw/2, phoneY=H*.5-ph/2;
    const {sx,sy,sw,sh,ctrX}=drawPhone(phoneX,phoneY,pw,ph,pr,step);

    // QR area
    const qS=72, qX=ctrX-qS/2, qY=sy+50;

    // Step 0: Idle / tap to pay
    if(step===0){
      const p=.88+.12*Math.sin(fr*.07);
      // Animated UPI logo placeholder
      const g=ctx.createRadialGradient(ctrX,qY+qS*.5,0,ctrX,qY+qS*.5,qS*.6);
      g.addColorStop(0,\`rgba(0,153,214,\${.08*p})\`); g.addColorStop(1,'transparent');
      ctx.beginPath(); ctx.arc(ctrX,qY+qS*.5,qS*.5,0,Math.PI*2); ctx.fillStyle=g; ctx.fill();
      ctx.font=\`\${26*p}px sans-serif\`; ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillText('📲',ctrX,qY+qS*.5); ctx.textBaseline='alphabetic';
      // Tap hint
      ctx.font='8px Nunito,sans-serif'; ctx.fillStyle=\`rgba(0,153,214,\${.6*p})\`;
      ctx.fillText('Scan to Pay',ctrX,qY+qS+16);
      // Ripple
      const rp=(fr%60)/60;
      ctx.beginPath(); ctx.arc(ctrX,qY+qS*.5,qS*.5*(.7+.4*rp),0,Math.PI*2);
      ctx.strokeStyle=\`rgba(0,153,214,\${.3*(1-rp)})\`; ctx.lineWidth=1.5; ctx.stroke();
    }

    // Step 1+: QR code
    if(step>=1){
      const qProg=step===1?Math.min(1,(fr%SDUR)/55):1;
      const cell=qS/7;

      // QR background
      ctx.fillStyle='rgba(0,10,30,.6)'; ctx.fillRect(qX-3,qY-3,qS+6,qS+6);

      // Finder pattern cells
      QP.forEach((row,r)=>row.forEach((v,col)=>{
        if(!v) return;
        const cp=Math.min(1,qProg*Math.max(.1,(1.2-(r+col)*.08)));
        const shade=r<3&&col<3||r<3&&col>3||r>3&&col<3?'255,255,255':'0,200,255';
        ctx.fillStyle=\`rgba(\${shade},\${.9*cp})\`;
        ctx.fillRect(qX+col*cell+.5,qY+r*cell+.5,cell-.9,cell-.9);
      }));

      // Inner data cells
      if(qProg>.4) innerC.forEach(([r,col])=>{
        ctx.fillStyle=\`rgba(0,200,255,\${.7*(qProg-.4)/0.6})\`;
        ctx.fillRect(qX+col*cell+.5,qY+r*cell+.5,cell-.9,cell-.9);
      });

      // Corner alignment marks
      if(qProg>.6){
        [[0,0],[0,5],[5,0]].forEach(([r,col])=>{
          const cell2=cell;
          ctx.strokeStyle=\`rgba(0,229,255,\${.8*qProg})\`;
          ctx.lineWidth=2; ctx.lineJoin='round';
          // L-shaped corner brackets
          const bx=qX+col*cell2-2, by=qY+r*cell2-2, bs=cell2*2.4;
          ctx.beginPath();
          ctx.moveTo(bx,by+10); ctx.lineTo(bx,by); ctx.lineTo(bx+10,by);
          ctx.moveTo(bx+bs-10,by); ctx.lineTo(bx+bs,by); ctx.lineTo(bx+bs,by+10);
          ctx.moveTo(bx,by+bs-10); ctx.lineTo(bx,by+bs); ctx.lineTo(bx+10,by+bs);
          ctx.moveTo(bx+bs-10,by+bs); ctx.lineTo(bx+bs,by+bs); ctx.lineTo(bx+bs,by+bs-10);
          ctx.stroke();
        });
      }
    }

    // Scan beam (step 1)
    if(step===1){
      beamY+=bDir; if(beamY>qS-4||beamY<4) bDir*=-1;
      const bG=ctx.createLinearGradient(qX,qY+beamY-8,qX,qY+beamY+8);
      bG.addColorStop(0,'transparent'); bG.addColorStop(.35,'rgba(0,240,255,.08)');
      bG.addColorStop(.5,'rgba(0,240,255,.95)'); bG.addColorStop(.65,'rgba(0,240,255,.08)'); bG.addColorStop(1,'transparent');
      ctx.fillStyle=bG; ctx.fillRect(qX-4,qY+beamY-8,qS+8,16);
      ctx.shadowColor='rgba(0,240,255,.8)'; ctx.shadowBlur=6;
      ctx.beginPath(); ctx.moveTo(qX,qY+beamY); ctx.lineTo(qX+qS,qY+beamY);
      ctx.strokeStyle='rgba(0,240,255,.9)'; ctx.lineWidth=1.5; ctx.stroke(); ctx.shadowBlur=0;
    }

    // Amount chip (step 2+)
    if(step>=2){
      const ay=qY+qS+10;
      // Card bg
      const cG=ctx.createLinearGradient(sx+6,ay-8,sx+6,ay+28);
      cG.addColorStop(0,'rgba(0,153,214,.15)'); cG.addColorStop(1,'rgba(0,153,214,.05)');
      ctx.fillStyle=cG; ctx.beginPath(); ctx.roundRect(sx+6,ay-8,sw-12,36,8); ctx.fill();
      ctx.strokeStyle='rgba(0,153,214,.25)'; ctx.lineWidth=1;
      ctx.beginPath(); ctx.roundRect(sx+6,ay-8,sw-12,36,8); ctx.stroke();
      ctx.font='bold 15px Nunito,sans-serif'; ctx.fillStyle='#fff';
      ctx.textAlign='center'; ctx.fillText('₹12,500.00',ctrX,ay+8);
      ctx.font='6.5px Nunito Sans'; ctx.fillStyle='rgba(255,255,255,.4)';
      ctx.fillText('merchant@speedvault',ctrX,ay+20);
    }

    // MPIN (step 2)
    if(step===2){
      const py=qY+qS+58;
      ctx.font='7.5px Nunito Sans'; ctx.fillStyle='rgba(255,255,255,.35)'; ctx.textAlign='center';
      ctx.fillText('Enter MPIN to confirm',ctrX,py-2);
      for(let i=0;i<6;i++){
        const filled=i<Math.floor((fr%SDUR)/26)+1;
        const dx=ctrX+(i-2.5)*12;
        ctx.beginPath(); ctx.arc(dx,py+12,5,0,Math.PI*2);
        if(filled){
          ctx.fillStyle='#0099D6'; ctx.shadowColor='#0099D6'; ctx.shadowBlur=10; ctx.fill(); ctx.shadowBlur=0;
        } else {
          ctx.fillStyle='rgba(255,255,255,.08)'; ctx.fill();
          ctx.strokeStyle='rgba(255,255,255,.2)'; ctx.lineWidth=1; ctx.stroke();
        }
      }
    }

    // Routing (step 3)
    if(step===3){
      const ry=qY+qS+52;
      const p=.65+.35*Math.sin(fr*.12);
      // Animated spinner
      ctx.save(); ctx.translate(ctrX-28,ry); ctx.rotate(fr*.08);
      ctx.strokeStyle=\`rgba(0,153,214,\${p})\`; ctx.lineWidth=1.5;
      ctx.beginPath(); ctx.arc(0,0,7,0,Math.PI*1.5); ctx.stroke();
      ctx.restore();
      ctx.font='bold 8px Nunito,sans-serif'; ctx.fillStyle=\`rgba(0,153,214,\${p})\`;
      ctx.textAlign='center'; ctx.fillText('Routing via SpeedVault',ctrX+6,ry+4);
      // Progress dots
      for(let i=0;i<3;i++){
        const da=(fr*.08+i*Math.PI*.66)%(Math.PI*2);
        ctx.beginPath(); ctx.arc(ctrX-8+i*8,ry+16,2.5+Math.sin(da)*1,0,Math.PI*2);
        ctx.fillStyle=\`rgba(0,153,214,\${.4+.5*Math.sin(da)})\`; ctx.fill();
      }
    }

    // Success (step 4)
    if(step>=4){
      const sy2=qY+qS+44, r=22;
      const cp=Math.min(1,(fr%SDUR)/20);
      // Animated circle fill
      ctx.beginPath(); ctx.arc(ctrX,sy2,r,0,Math.PI*2);
      ctx.fillStyle='rgba(62,188,121,.18)'; ctx.fill();
      ctx.shadowColor='#3EBC79'; ctx.shadowBlur=20*cp;
      ctx.strokeStyle='#3EBC79'; ctx.lineWidth=2.5; ctx.stroke(); ctx.shadowBlur=0;
      // Animated check
      if(cp>.2){
        const cp2=Math.min(1,(cp-.2)/.8);
        ctx.beginPath(); ctx.moveTo(ctrX-11,sy2);
        const mx=ctrX-4, my=sy2+8;
        const ex=ctrX+11, ey=sy2-9;
        if(cp2<.5){
          const t=cp2*2;
          ctx.lineTo(mx*t+(ctrX-11)*(1-t),my*t+(sy2)*(1-t));
        } else {
          ctx.lineTo(mx,my);
          const t=(cp2-.5)*2;
          ctx.lineTo(mx+(ex-mx)*t,my+(ey-my)*t);
        }
        ctx.strokeStyle='#3EBC79'; ctx.lineWidth=3; ctx.lineCap='round'; ctx.lineJoin='round'; ctx.stroke();
      }
      // Paid label
      ctx.font='bold 9px Nunito,sans-serif'; ctx.fillStyle='rgba(62,188,121,.95)';
      ctx.textAlign='center'; ctx.fillText('PAYMENT SUCCESS',ctrX,sy2+r+14);
    }

    // Phone home bar
    ctx.fillStyle='rgba(255,255,255,.15)';
    ctx.beginPath(); ctx.roundRect(ctrX-22,sy+sh-12,44,4,2); ctx.fill();

    // ── RIGHT SIDE: Routing nodes ──
    const nX=W*.74;
    const nData=[
      {y:H*.22, label:'HDFC Bank', sub:'Payer →', col:'#0099D6', r:26, icon:'🏦'},
      {y:H*.5,  label:'SpeedVault', sub:'Switch', col:'#7C3AED', r:32, icon:'⚡', big:true},
      {y:H*.78, label:'Merchant', sub:'Receiving', col:'#3EBC79', r:26, icon:'🏪'},
    ];

    // Vertical connection lines
    ctx.setLineDash([5,7]);
    nData.forEach((n,i)=>{
      if(!nData[i+1]) return;
      const n2=nData[i+1];
      const g=ctx.createLinearGradient(nX,n.y,nX,n2.y);
      g.addColorStop(0,n.col+'55'); g.addColorStop(1,n2.col+'55');
      ctx.beginPath(); ctx.moveTo(nX,n.y+n.r); ctx.lineTo(nX,n2.y-n2.r);
      ctx.strokeStyle=g; ctx.lineWidth=2; ctx.stroke();
    });
    ctx.setLineDash([]); ctx.lineDashOffset=0;

    // Curved phone→switch connection
    if(step>=3){
      const px1=phoneX+pw, py1=H*.5;
      const nx1=nX-nData[1].r;
      const cp1x=px1+(nx1-px1)*.4, cp1y=H*.32;
      const cp2x=px1+(nx1-px1)*.7, cp2y=H*.4;
      const g=ctx.createLinearGradient(px1,py1,nx1,nData[1].y);
      g.addColorStop(0,'rgba(0,153,214,.4)'); g.addColorStop(1,'rgba(124,58,237,.4)');
      ctx.setLineDash([4,5]);
      ctx.beginPath(); ctx.moveTo(px1,py1);
      ctx.bezierCurveTo(cp1x,cp1y,cp2x,cp2y,nx1,nData[1].y);
      ctx.strokeStyle=g; ctx.lineWidth=1.5;
      ctx.lineDashOffset=-(fr*.7)%18; ctx.stroke();
      ctx.setLineDash([]); ctx.lineDashOffset=0;

      // Packet on curve
      const tp=(fr*1.3)%100/100;
      const bx2=bz(tp,px1,cp1x,cp2x,nx1), by2=bz(tp,py1,cp1y,cp2y,nData[1].y);
      for(let t=1;t<=8;t++){
        const tt=Math.max(0,tp-t*.03);
        const bx3=bz(tt,px1,cp1x,cp2x,nx1), by3=bz(tt,py1,cp1y,cp2y,nData[1].y);
        ctx.beginPath(); ctx.arc(bx3,by3,Math.max(.5,4-t*.4),0,Math.PI*2);
        ctx.fillStyle=\`rgba(0,153,214,\${(8-t)/8*.7})\`; ctx.fill();
      }
      ctx.beginPath(); ctx.arc(bx2,by2,5.5,0,Math.PI*2);
      ctx.fillStyle='#00BFFF'; ctx.shadowColor='#00BFFF'; ctx.shadowBlur=14; ctx.fill(); ctx.shadowBlur=0;

      // Amount label on packet
      if(tp>.3&&tp<.7){
        ctx.fillStyle='rgba(0,0,0,.65)';
        ctx.beginPath(); ctx.roundRect(bx2-24,by2-20,48,14,7); ctx.fill();
        ctx.font='bold 7px Nunito,sans-serif'; ctx.fillStyle='rgba(255,255,255,.8)'; ctx.textAlign='center';
        ctx.fillText('₹12,500',bx2,by2-10);
      }
    }

    // Switch→merchant packet (step 4)
    if(step>=4){
      const tp=(fr*1.6)%100/100;
      const y1=nData[1].y+nData[1].r, y2=nData[2].y-nData[2].r;
      const curY=y1+(y2-y1)*tp;
      const wobble=Math.sin(tp*Math.PI)*12;
      for(let t=1;t<=7;t++){
        const tt=Math.max(0,tp-t*.04);
        const cy2=y1+(y2-y1)*tt+Math.sin(tt*Math.PI)*12;
        ctx.beginPath(); ctx.arc(nX+wobble*(t/7),cy2,Math.max(.5,3.5-t*.4),0,Math.PI*2);
        ctx.fillStyle=\`rgba(62,188,121,\${(7-t)/7*.7})\`; ctx.fill();
      }
      ctx.beginPath(); ctx.arc(nX+wobble,curY,5.5,0,Math.PI*2);
      ctx.fillStyle='#3EBC79'; ctx.shadowColor='#3EBC79'; ctx.shadowBlur=14; ctx.fill(); ctx.shadowBlur=0;
    }

    // Draw nodes
    nData.forEach((n,i)=>{
      const pulse=.75+.25*Math.sin(fr*.055+i*1.3);
      // Multi-ring glow
      [3.2,2.2,1.5].forEach((m,gi)=>{
        const g2=ctx.createRadialGradient(nX,n.y,0,nX,n.y,n.r*m*pulse);
        g2.addColorStop(0,n.col+['12','1E','30'][gi]); g2.addColorStop(1,n.col+'00');
        ctx.beginPath(); ctx.arc(nX,n.y,n.r*m*pulse,0,Math.PI*2); ctx.fillStyle=g2; ctx.fill();
      });
      // Body
      const nG=ctx.createRadialGradient(nX-n.r*.35,n.y-n.r*.35,0,nX,n.y,n.r);
      nG.addColorStop(0,n.col+(step>i?'60':'30')); nG.addColorStop(1,'#060D20');
      ctx.beginPath(); ctx.arc(nX,n.y,n.r,0,Math.PI*2); ctx.fillStyle=nG; ctx.fill();
      // Border
      if(step===i+1){ctx.shadowColor=n.col; ctx.shadowBlur=18;}
      ctx.strokeStyle=n.col+(step===i+1?'ff':step>i+1?'aa':'44');
      ctx.lineWidth=step===i+1?2.5:1.5; ctx.stroke(); ctx.shadowBlur=0;
      // Done overlay
      if(step>i+1){
        ctx.beginPath(); ctx.arc(nX,n.y,n.r,0,Math.PI*2);
        ctx.fillStyle='rgba(62,188,121,.1)'; ctx.fill();
      }
      // Icon
      ctx.font=\`\${n.big?16:13}px sans-serif\`; ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillText(n.icon,nX,n.y-1); ctx.textBaseline='alphabetic';
      // Label below
      ctx.font=\`bold \${n.big?9:8}px Nunito,sans-serif\`;
      ctx.fillStyle=step>i?n.col:'rgba(255,255,255,.35)';
      ctx.textAlign='center'; ctx.fillText(n.label,nX,n.y+n.r+13);
      ctx.font='7px Nunito Sans'; ctx.fillStyle='rgba(255,255,255,.25)';
      ctx.fillText(n.sub,nX,n.y+n.r+23);
      // Active ring animation
      if(step===i+1){
        const rp=(.5+.5*Math.sin(fr*.08))*8;
        ctx.beginPath(); ctx.arc(nX,n.y,n.r+rp,0,Math.PI*2);
        ctx.strokeStyle=n.col+'25'; ctx.lineWidth=2; ctx.stroke();
      }
    });

    // Particles
    for(let i=parts.length-1;i>=0;i--){
      const p=parts[i];
      ctx.beginPath(); ctx.arc(p.x,p.y,p.r*p.a,0,Math.PI*2);
      ctx.fillStyle=\`rgba(\${p.col},\${p.a})\`; ctx.fill();
      p.x+=p.vx; p.y+=p.vy; p.vy+=.1; p.a-=.022; p.r*=.97;
      if(p.a<=0) parts.splice(i,1);
    }

    ctx.textAlign='left';
    fr++;
    const ns=Math.floor((fr%(STEPS*SDUR))/SDUR);
    if(ns!==step){
      if(ns===4) burst(ctrX,phoneY+ph*.5,30,['0,153,214','62,188,121','255,206,0','124,58,237']);
      step=ns;
      sEls.forEach((el,i)=>{el.classList.toggle('active',i===step);el.classList.toggle('done',i<step);});
    }
    requestAnimationFrame(draw);
  }
  draw();
})();

/* ══════════════════════════════════════════════════════
   ANIM 2 — TRANSACTION JOURNEY
══════════════════════════════════════════════════════ */
(function(){
  const c=document.getElementById('journeyCanvas'); if(!c) return;
  const ctx=c.getContext('2d');
  let W,H; const dpr=window.devicePixelRatio||1;
  function resize(){var _w=c.offsetWidth||(c.parentElement&&c.parentElement.offsetWidth)||600,_h=c.offsetHeight||520;_w=_w<1?600:_w;_h=_h<1?520:_h;if(_w===W&&_h===H)return;W=_w;H=_h;c.width=W*dpr;c.height=H*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);}
  resize(); window.addEventListener('resize',resize);

  const STEPS=5,SDUR=130; let fr=0,step=0;
  const sEls=document.querySelectorAll('#journeySteps .anim-step');
  let txCount=1247;
  setInterval(()=>{txCount+=Math.floor(Math.random()*6+2);const el=document.getElementById('jtxCount');if(el)el.textContent=txCount.toLocaleString('en-IN');},1400);

  const nodes=[
    {label:'Payer',sub:'HDFC VPA',col:'#0099D6',icon:'👤'},
    {label:'SpeedVault',sub:'Switch',col:'#7C3AED',icon:'⚡',big:true},
    {label:'NPCI',sub:'Validator',col:'#1A56DB',icon:'🏛'},
    {label:'Payee Bank',sub:'Axis VPA',col:'#3EBC79',icon:'🏦'},
    {label:'Merchant',sub:'Confirmed',col:'#FFCE00',icon:'🏪'},
  ];

  const pkts=[];
  setInterval(()=>{
    if(step<1) return;
    const maxSeg=Math.min(step,nodes.length-1);
    for(let seg=0;seg<maxSeg;seg++){
      if(Math.random()>.55) pkts.push({seg,t:0,sp:.014+Math.random()*.014,blocked:seg===1&&Math.random()<.06,trail:[],style:Math.floor(Math.random()*3),amt:['₹350','₹1,200','₹12,500','₹89,000','₹4,200','₹2,750','₹55,000'][Math.floor(Math.random()*7)]});
    }
  },600);

  const feed=[]; const amts=['₹500','₹1,200','₹89,000','₹350','₹12,500','₹4,200','₹99,999','₹2,750','₹55,000'];
  setInterval(()=>{feed.unshift({amt:amts[Math.floor(Math.random()*amts.length)],ok:Math.random()>.06,a:1});if(feed.length>8) feed.pop();},800);

  function draw(){
    if(!W||!H||W<2||H<2){resize();if(!W||W<2){setTimeout(draw,50);return;}}
    ctx.clearRect(0,0,W,H);
    const bg=ctx.createRadialGradient(W*.5,H*.42,0,W*.5,H*.5,Math.max(W,H)*.8);
    bg.addColorStop(0,'#070E22'); bg.addColorStop(1,'#030610');
    ctx.fillStyle=bg; ctx.fillRect(0,0,W,H);

    // Dot grid
    for(let x=0;x<W;x+=44){for(let y=0;y<H;y+=44){
      ctx.beginPath(); ctx.arc(x,y,1,0,Math.PI*2);
      ctx.fillStyle=\`rgba(26,43,107,\${.08+.04*Math.sin((x-y)*.02+fr*.012)})\`; ctx.fill();
    }}

    const margin=44, nodeY=H*.42, spacing=(W-margin*2)/(nodes.length-1);

    // ── 3D PIPE ──
    nodes.forEach((n,i)=>{
      if(i===nodes.length-1) return;
      const x1=margin+i*spacing, x2=margin+(i+1)*spacing;
      const activated=step>i;
      // Pipe shadow
      ctx.beginPath(); ctx.moveTo(x1,nodeY+6); ctx.lineTo(x2,nodeY+6);
      ctx.strokeStyle='rgba(0,0,0,.6)'; ctx.lineWidth=18; ctx.stroke();
      // Pipe bottom face
      ctx.beginPath(); ctx.moveTo(x1,nodeY+5); ctx.lineTo(x2,nodeY+5);
      ctx.strokeStyle=activated?'rgba(0,80,160,.5)':'rgba(10,20,50,.7)'; ctx.lineWidth=14; ctx.stroke();
      // Pipe main
      const pG=ctx.createLinearGradient(x1,nodeY-7,x1,nodeY+7);
      pG.addColorStop(0,activated?'rgba(0,153,214,.55)':'rgba(15,30,70,.9)');
      pG.addColorStop(.5,activated?'rgba(0,100,180,.4)':'rgba(10,22,55,.8)');
      pG.addColorStop(1,activated?'rgba(0,60,130,.3)':'rgba(8,15,40,.7)');
      ctx.beginPath(); ctx.moveTo(x1,nodeY); ctx.lineTo(x2,nodeY);
      ctx.strokeStyle=pG; ctx.lineWidth=14; ctx.stroke();
      // Pipe highlight
      ctx.beginPath(); ctx.moveTo(x1,nodeY-5); ctx.lineTo(x2,nodeY-5);
      ctx.strokeStyle=activated?'rgba(100,200,255,.25)':'rgba(255,255,255,.04)'; ctx.lineWidth=2; ctx.stroke();
      // Animated flow inside pipe
      if(activated){
        ctx.save(); ctx.beginPath(); ctx.rect(x1,nodeY-7,x2-x1,14); ctx.clip();
        const fo=-(fr*1.2)%30;
        for(let ox=fo;ox<x2-x1+30;ox+=30){
          ctx.fillStyle='rgba(0,200,255,.06)';
          ctx.beginPath(); ctx.rect(x1+ox,nodeY-6,20,12); ctx.fill();
        }
        ctx.restore();
      }
    });

    // ── PACKETS ──
    for(let i=pkts.length-1;i>=0;i--){
      const pk=pkts[i];
      const seg=Math.min(pk.seg,nodes.length-2);
      const x1=margin+seg*spacing, x2=margin+(seg+1)*spacing;
      const px=x1+(x2-x1)*pk.t;
      const arc=Math.sin(pk.t*Math.PI)*-22;
      const py=nodeY+arc;
      // ── Comet tail ──
      pk.trail.push({x:px,y:py});
      if(pk.trail.length>22) pk.trail.shift();
      const pCol=pk.blocked?'231,76,60':'0,180,255';
      const pHex=pk.blocked?'#E74C3C':'#00B4FF';
      pk.trail.forEach((pt,ti)=>{
        const ta=ti/pk.trail.length;
        ctx.beginPath(); ctx.arc(pt.x,pt.y,Math.max(.3,5*ta*ta),0,Math.PI*2);
        ctx.fillStyle=\`rgba(\${pCol},\${ta*.45})\`; ctx.fill();
      });

      // Halo
      const haloG=ctx.createRadialGradient(px,py,0,px,py,20);
      haloG.addColorStop(0,\`rgba(\${pCol},.2)\`); haloG.addColorStop(1,\`rgba(\${pCol},0)\`);
      ctx.beginPath(); ctx.arc(px,py,20,0,Math.PI*2); ctx.fillStyle=haloG; ctx.fill();

      ctx.shadowColor=pHex; ctx.shadowBlur=13;
      const pkAmt=pk.amt||'₹12,500';
      const st=pk.style||0;

      if(st===0){
        // Style 0: Horizontal card
        const cw=54,ch=28,cx=px-cw/2,cy=py-ch/2;
        const cG=ctx.createLinearGradient(cx,cy,cx+cw,cy+ch);
        cG.addColorStop(0,pk.blocked?'rgba(80,10,10,.92)':'rgba(0,25,55,.92)');
        cG.addColorStop(1,pk.blocked?'rgba(50,5,5,.92)':'rgba(0,15,40,.92)');
        ctx.fillStyle=cG; ctx.beginPath(); ctx.roundRect(cx,cy,cw,ch,6); ctx.fill();
        ctx.shadowBlur=0;
        ctx.strokeStyle=\`rgba(\${pCol},.65)\`; ctx.lineWidth=1.2;
        ctx.beginPath(); ctx.roundRect(cx,cy,cw,ch,6); ctx.stroke();
        ctx.fillStyle=\`rgba(\${pCol},.7)\`;
        ctx.beginPath(); ctx.roundRect(cx,cy,cw,3,[6,6,0,0]); ctx.fill();
        const ix=cx+9,iy=py;
        ctx.strokeStyle=\`rgba(\${pCol},.9)\`; ctx.lineWidth=1.5; ctx.lineCap='round'; ctx.lineJoin='round';
        if(pk.blocked){
          ctx.beginPath(); ctx.moveTo(ix-3,iy-3); ctx.lineTo(ix+3,iy+3); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(ix+3,iy-3); ctx.lineTo(ix-3,iy+3); ctx.stroke();
        } else {
          ctx.beginPath(); ctx.moveTo(ix-4,iy); ctx.lineTo(ix+4,iy); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(ix+1,iy-3); ctx.lineTo(ix+4,iy); ctx.lineTo(ix+1,iy+3); ctx.stroke();
        }
        ctx.font='bold 8px Inter,sans-serif';
        ctx.fillStyle=pk.blocked?'rgba(255,140,130,.95)':'rgba(0,230,255,.95)';
        ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.fillText(pkAmt,cx+cw*.62,py+1); ctx.textBaseline='alphabetic';
        ctx.font='5px Inter,sans-serif'; ctx.fillStyle=\`rgba(\${pCol},.4)\`;
        ctx.textAlign='left'; ctx.fillText(pk.blocked?'ERR':'UPI',cx+4,cy+ch-4);

      } else if(st===1){
        // Style 1: Tall vertical badge
        const bw=28,bh=36,bx=px-bw/2,by=py-bh/2;
        ctx.fillStyle=pk.blocked?'rgba(60,5,5,.94)':'rgba(0,20,50,.94)';
        ctx.beginPath(); ctx.roundRect(bx,by,bw,bh,5); ctx.fill();
        ctx.shadowBlur=0;
        ctx.strokeStyle=\`rgba(\${pCol},.6)\`; ctx.lineWidth=1;
        ctx.beginPath(); ctx.roundRect(bx,by,bw,bh,5); ctx.stroke();
        ctx.fillStyle=\`rgba(\${pCol},.8)\`;
        ctx.beginPath(); ctx.roundRect(bx,by,3,bh,[5,0,0,5]); ctx.fill();
        ctx.font='bold 9px Inter,sans-serif';
        ctx.fillStyle=\`rgba(\${pCol},.9)\`; ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.fillText('₹',px+1,by+11);
        ctx.strokeStyle=\`rgba(\${pCol},.2)\`; ctx.lineWidth=.8;
        ctx.beginPath(); ctx.moveTo(bx+5,by+18); ctx.lineTo(bx+bw-5,by+18); ctx.stroke();
        ctx.font='bold 6.5px Inter,sans-serif';
        ctx.fillStyle=pk.blocked?'rgba(255,160,140,.9)':'rgba(100,230,255,.9)';
        let sa=pkAmt.replace('₹','').replace(',','');
        if(sa.length>5) sa=sa.substring(0,4)+'…';
        ctx.fillText(sa,px+1,by+27); ctx.textBaseline='alphabetic';
        ctx.fillStyle=\`rgba(\${pCol},.7)\`;
        ctx.beginPath(); ctx.arc(px,by+bh-5,2.5,0,Math.PI*2); ctx.fill();

      } else {
        // Style 2: Rounded pill
        const pw=58,ph=22,px3=px-pw/2,py3=py-ph/2;
        const pG2=ctx.createLinearGradient(px3,py3,px3+pw,py3+ph);
        pG2.addColorStop(0,pk.blocked?'rgba(90,12,12,.9)':'rgba(0,30,65,.9)');
        pG2.addColorStop(1,pk.blocked?'rgba(40,4,4,.9)':'rgba(0,12,35,.9)');
        ctx.fillStyle=pG2; ctx.beginPath(); ctx.roundRect(px3,py3,pw,ph,ph/2); ctx.fill();
        ctx.shadowBlur=0;
        ctx.strokeStyle=\`rgba(\${pCol},.6)\`; ctx.lineWidth=1;
        ctx.beginPath(); ctx.roundRect(px3,py3,pw,ph,ph/2); ctx.stroke();
        ctx.fillStyle=\`rgba(\${pCol},.9)\`;
        ctx.beginPath(); ctx.arc(px3+10,py,4,0,Math.PI*2); ctx.fill();
        ctx.fillStyle='rgba(255,255,255,.6)';
        ctx.beginPath(); ctx.arc(px3+10,py,1.8,0,Math.PI*2); ctx.fill();
        ctx.font='bold 7.5px Inter,sans-serif';
        ctx.fillStyle=pk.blocked?'rgba(255,150,130,.95)':'rgba(0,220,255,.95)';
        ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.fillText(pkAmt,px3+pw*.6,py); ctx.textBaseline='alphabetic';
      }
      pk.t+=pk.sp; if(pk.t>=1) pkts.splice(i,1);
    }

    // ── NODES ──
    nodes.forEach((n,i)=>{
      const nx=margin+i*spacing, r=n.big?30:23;
      const isAct=step===i, isDone=step>i;
      const pulse=isAct ? .72+.28*Math.sin(fr*.08) : 1;

      // Multi-ring glow
      [3.5,2.4,1.6].forEach((m,gi)=>{
        const g=ctx.createRadialGradient(nx,nodeY,0,nx,nodeY,r*m*pulse);
        g.addColorStop(0,n.col+['0E','18','25'][gi]); g.addColorStop(1,n.col+'00');
        ctx.beginPath(); ctx.arc(nx,nodeY,r*m*pulse,0,Math.PI*2); ctx.fillStyle=g; ctx.fill();
      });

      // Node body
      const nG=ctx.createRadialGradient(nx-r*.35,nodeY-r*.35,0,nx,nodeY,r);
      nG.addColorStop(0,(isDone||isAct)?n.col+'65':'rgba(12,22,52,.95)');
      nG.addColorStop(1,'#070E22');
      ctx.beginPath(); ctx.arc(nx,nodeY,r,0,Math.PI*2); ctx.fillStyle=nG; ctx.fill();

      // Ring
      if(isAct){ctx.shadowColor=n.col; ctx.shadowBlur=22;}
      ctx.strokeStyle=n.col+(isAct?'FF':isDone?'BB':'33');
      ctx.lineWidth=isAct?3:1.5; ctx.stroke(); ctx.shadowBlur=0;

      // Done flash
      if(isDone){
        ctx.beginPath(); ctx.arc(nx,nodeY,r,0,Math.PI*2);
        ctx.fillStyle='rgba(62,188,121,.12)'; ctx.fill();
        // Tiny check badge
        ctx.fillStyle='rgba(62,188,121,.9)';
        ctx.beginPath(); ctx.arc(nx+r-2,nodeY-r+2,7,0,Math.PI*2); ctx.fill();
        ctx.font='bold 8px sans-serif'; ctx.fillStyle='#fff';
        ctx.textAlign='center'; ctx.textBaseline='middle'; ctx.fillText('✓',nx+r-2,nodeY-r+2); ctx.textBaseline='alphabetic';
      }

      // Icon
      ctx.font=\`\${n.big?16:13}px sans-serif\`; ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillText(n.icon,nx,nodeY); ctx.textBaseline='alphabetic';

      // Label
      ctx.font=\`bold \${n.big?9:8}px Nunito,sans-serif\`; ctx.fillStyle=isAct||isDone?n.col:'rgba(255,255,255,.28)';
      ctx.textAlign='center'; ctx.fillText(n.label,nx,nodeY+r+15);
      ctx.font='7px Nunito Sans'; ctx.fillStyle='rgba(255,255,255,.22)';
      ctx.fillText(n.sub,nx,nodeY+r+25);

      // Step badge
      ctx.fillStyle=isDone?'rgba(62,188,121,.3)':isAct?n.col+'33':'rgba(255,255,255,.05)';
      ctx.beginPath(); ctx.arc(nx-r+2,nodeY-r+2,9,0,Math.PI*2); ctx.fill();
      ctx.font='bold 8px Nunito,sans-serif'; ctx.fillStyle=isDone?'#3EBC79':isAct?n.col:'rgba(255,255,255,.2)';
      ctx.textAlign='center'; ctx.textBaseline='middle'; ctx.fillText(i+1,nx-r+2,nodeY-r+2); ctx.textBaseline='alphabetic';

      // Active pulse ring
      if(isAct){
        const rp=(fr%40)/40;
        ctx.beginPath(); ctx.arc(nx,nodeY,r+4+rp*14,0,Math.PI*2);
        ctx.strokeStyle=n.col+Math.floor((1-rp)*40).toString(16).padStart(2,'0');
        ctx.lineWidth=2; ctx.stroke();
      }
    });

    // ── TIMELINE ──
    const bX=margin, bW=W-margin*2, bY=H*.71;
    ctx.fillStyle='rgba(255,255,255,.05)'; ctx.beginPath(); ctx.roundRect(bX,bY,bW,8,4); ctx.fill();
    const prog=Math.min(1,step/(nodes.length-1));
    const fG=ctx.createLinearGradient(bX,0,bX+bW,0);
    fG.addColorStop(0,'#1A2B6B'); fG.addColorStop(.35,'#0099D6'); fG.addColorStop(.7,'#7C3AED'); fG.addColorStop(1,'#3EBC79');
    ctx.fillStyle=fG; ctx.beginPath(); ctx.roundRect(bX,bY,bW*prog,8,4); ctx.fill();
    // Animated leading edge glow
    if(prog>0&&prog<1){
      const ex=bX+bW*prog;
      const eG=ctx.createRadialGradient(ex,bY+4,0,ex,bY+4,16);
      eG.addColorStop(0,'rgba(0,200,255,.4)'); eG.addColorStop(1,'transparent');
      ctx.fillStyle=eG; ctx.beginPath(); ctx.arc(ex,bY+4,16,0,Math.PI*2); ctx.fill();
    }
    // Tick dots
    nodes.forEach((_,i)=>{
      const tx=bX+i*(bW/(nodes.length-1));
      ctx.beginPath(); ctx.arc(tx,bY+4,i<=step?6:4,0,Math.PI*2);
      ctx.fillStyle=i<=step?'#3EBC79':'rgba(255,255,255,.12)'; ctx.fill();
      if(i<=step){
        ctx.font='bold 8px Nunito'; ctx.fillStyle='#070E22'; ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.fillText('✓',tx,bY+4); ctx.textBaseline='alphabetic';
      }
    });
    const ms=[0,6,45,180,320];
    ctx.font='bold 8px Nunito,sans-serif'; ctx.fillStyle='rgba(255,255,255,.3)'; ctx.textAlign='center';
    ctx.fillText(\`\${ms[step]||0}ms elapsed  •  Total: ~320ms\`,W*.5,bY+22);

    // ── LIVE FEED panel ──
    const fX=W-175, fY=H*.76;
    const feedBoxH=Math.max(30,feed.length*18+24);
    ctx.fillStyle='rgba(4,8,20,.8)';
    ctx.beginPath(); ctx.roundRect(fX-10,fY-10,173,feedBoxH,10); ctx.fill();
    ctx.strokeStyle='rgba(0,153,214,.12)'; ctx.lineWidth=1;
    ctx.beginPath(); ctx.roundRect(fX-10,fY-10,173,feedBoxH,10); ctx.stroke();
    ctx.fillStyle='rgba(0,153,214,.8)'; ctx.beginPath(); ctx.arc(fX,fY+3,4,0,Math.PI*2); ctx.fill();
    ctx.font='bold 7px Nunito,sans-serif'; ctx.fillStyle='rgba(0,153,214,.7)'; ctx.textAlign='left';
    ctx.fillText('LIVE TRANSACTIONS',fX+10,fY+5);
    feed.forEach((fd,i)=>{
      ctx.font='8px Nunito,sans-serif';
      ctx.fillStyle=\`rgba(\${fd.ok?'62,188,121':'231,76,60'},\${Math.min(1,fd.a)})\`;
      ctx.fillText(\`\${fd.amt}  \${fd.ok?'✓ OK':'✗ FAIL'}\`,fX,fY+20+i*18);
      fd.a-=.001;
    });
    ctx.textAlign='left';

    fr++;
    const ns=Math.floor((fr%(STEPS*SDUR))/SDUR);
    if(ns!==step){step=ns;sEls.forEach((el,i)=>{el.classList.toggle('active',i===step);el.classList.toggle('done',i<step);});}
    requestAnimationFrame(draw);
  }
  draw();
})();

/* ══════════════════════════════════════════════════════
   ANIM 3 — FRAUD DETECTION  v2
   A live transaction interception visualiser:
   - Transactions stream L→R through 5 AI shield layers
   - Each shield lights up as it scores the packet
   - Suspicious packets explode with red alert burst
   - Clean packets pass through with green trace
   - Bottom: rotating threat radar + live counters
   - Top: scrolling live threat feed log
══════════════════════════════════════════════════════ */
(function(){
  var c=document.getElementById('fraudDetCanvas');
  if(!c) return;
  var ctx=c.getContext('2d');
  var dpr=window.devicePixelRatio||1;
  var W=600, H=520;

  function resize(){
    var w=c.offsetWidth||600, h=c.offsetHeight||520;
    if(w===W && h===H) return;
    W=w; H=h;
    c.width=W*dpr; c.height=H*dpr;
    ctx.setTransform(dpr,0,0,dpr,0,0);
  }
  resize();
  window.addEventListener('resize',resize);

  var STEPS=5, SDUR=140, fr=0, step=0;
  var sEls=document.querySelectorAll('#fraudSteps .anim-step');

  var fraudCount=1247;
  setInterval(function(){
    fraudCount+=Math.floor(Math.random()*3+1);
    var el=document.getElementById('fraudBlocked');
    if(el) el.textContent=fraudCount.toLocaleString('en-IN');
  },2200);

  // Shields
  var SHIELDS=[
    {xF:.18,label:'Velocity',  sub:'Rate limit',  col:'#0099D6',r:24},
    {xF:.33,label:'Geo-fence', sub:'Location',    col:'#7C3AED',r:24},
    {xF:.48,label:'Device',    sub:'Fingerprint', col:'#0EA5E9',r:24},
    {xF:.63,label:'Behaviour', sub:'Pattern',     col:'#8B5CF6',r:24},
    {xF:.78,label:'ML Score',  sub:'Risk model',  col:'#6366F1',r:28},
  ];

  // Packets
  var pkts=[];
  var AMTS=['Rs.350','Rs.1,200','Rs.12,500','Rs.89,000','Rs.500','Rs.4,200','Rs.55,000'];

  function spawnPkt(){
    var blocked=Math.random()<.15;
    pkts.push({
      x:W*.05, y:H*(.2+Math.random()*.6),
      vx:1.4+Math.random()*1.0,
      blocked:blocked,
      blockAt:blocked?Math.floor(Math.random()*SHIELDS.length):-1,
      phase:'travel', shieldIdx:0,
      exR:0, exA:1,
      trail:[], amt:AMTS[Math.floor(Math.random()*AMTS.length)],
      wobble:(Math.random()-.5)*.3,
      style:Math.floor(Math.random()*3)
    });
  }
  setInterval(spawnPkt,600);

  // Bursts
  var bursts=[];
  function addBurst(bx,by){
    for(var i=0;i<16;i++){
      var a=Math.random()*Math.PI*2, sp=1.5+Math.random()*3.5;
      bursts.push({x:bx,y:by,vx:Math.cos(a)*sp,vy:Math.sin(a)*sp-1,a:1,r:2+Math.random()*2,ring:false});
    }
    bursts.push({x:bx,y:by,r:1,a:1,ring:true,vr:3});
  }

  // Flashes
  var flashes=[];
  function addFlash(x,y,col){flashes.push({x:x,y:y,r:1,a:1,col:col});}

  // Threat log
  var threatLog=[];
  var THREATS=['Velocity spike','Geo mismatch detected','Device spoof','Duplicate merchant ID',
    'VPA pattern match','Amount threshold breach','Card BIN blacklisted','Impossible travel'];
  setInterval(function(){
    if(Math.random()>.5) return;
    var isBlocked=Math.random()<.35;
    threatLog.unshift({
      txt:THREATS[Math.floor(Math.random()*THREATS.length)],
      amt:AMTS[Math.floor(Math.random()*AMTS.length)],
      blocked:isBlocked,
      a:1
    });
    if(threatLog.length>7) threatLog.pop();
  },1200);

  // Radar dots
  var radarDots=[];
  setInterval(function(){
    var a=Math.random()*Math.PI*2, d=Math.random()*.85, hot=Math.random()<.2;
    radarDots.push({a:a,d:d,age:0,hot:hot});
    if(radarDots.length>24) radarDots.shift();
  },420);

  function drawShield(x,y,r,col,active,lit){
    var p=active?(.72+.28*Math.sin(fr*.1)):1;
    // outer glow
    var g=ctx.createRadialGradient(x,y,0,x,y,Math.max(r*2.8*p,1));
    g.addColorStop(0,col+(active?'30':'18')); g.addColorStop(1,col+'00');
    ctx.beginPath(); ctx.arc(x,y,r*2.8*p,0,Math.PI*2); ctx.fillStyle=g; ctx.fill();
    // body
    var bg=ctx.createRadialGradient(x,y,0,x,y,Math.max(r,1));
    bg.addColorStop(0,lit?col+'44':'rgba(8,12,32,.95)'); bg.addColorStop(1,'#05080F');
    ctx.beginPath(); ctx.arc(x,y,r,0,Math.PI*2); ctx.fillStyle=bg; ctx.fill();
    if(active){ctx.shadowColor=col; ctx.shadowBlur=16;}
    ctx.strokeStyle=col+(active?'FF':lit?'BB':'33');
    ctx.lineWidth=active?2.5:1.5; ctx.stroke(); ctx.shadowBlur=0;
    // shield shape
    var sc=r*.52;
    ctx.save(); ctx.translate(x,y);
    ctx.beginPath();
    ctx.moveTo(0,-sc); ctx.lineTo(sc*.65,-sc*.38);
    ctx.lineTo(sc*.65,sc*.18); ctx.quadraticCurveTo(sc*.65,sc*.85,0,sc);
    ctx.quadraticCurveTo(-sc*.65,sc*.85,-sc*.65,sc*.18);
    ctx.lineTo(-sc*.65,-sc*.38); ctx.closePath();
    ctx.fillStyle=lit?col+'33':'rgba(255,255,255,.03)'; ctx.fill();
    ctx.strokeStyle=lit?col+'66':'rgba(255,255,255,.08)'; ctx.lineWidth=1; ctx.stroke();
    if(lit){
      ctx.beginPath(); ctx.moveTo(-sc*.25,sc*.05); ctx.lineTo(-sc*.05,sc*.28); ctx.lineTo(sc*.28,-sc*.15);
      ctx.strokeStyle=active?col:'rgba(255,255,255,.6)'; ctx.lineWidth=1.8; ctx.lineCap='round'; ctx.stroke();
    }
    ctx.restore();
  }

  function draw(){
    ctx.clearRect(0,0,W,H);

    // BG
    var bg=ctx.createRadialGradient(W*.5,H*.45,0,W*.5,H*.5,Math.max(W,H)*.85);
    bg.addColorStop(0,'#060C1E'); bg.addColorStop(1,'#020510');
    ctx.fillStyle=bg; ctx.fillRect(0,0,W,H);

    // Dot grid
    for(var gx=0;gx<W;gx+=38){for(var gy=0;gy<H;gy+=38){
      var ga=.022+.016*Math.abs(Math.sin((gx+gy)*.014+fr*.01));
      ctx.beginPath(); ctx.arc(gx,gy,1,0,Math.PI*2);
      ctx.fillStyle='rgba(99,102,241,'+ga+')'; ctx.fill();
    }}

    // Threat log top-right
    // ── TRANSACTION HISTORY PANEL ──
    var rowH=22, maxRows=6;
    var lX=W*.5, lY=H*.02, lW=W*.48;
    var visRows=Math.min(threatLog.length, maxRows);
    var lH=visRows*rowH+28;
    if(visRows>0){
      // Panel bg
      ctx.fillStyle='rgba(4,8,22,.88)';
      ctx.beginPath(); ctx.roundRect(lX,lY,lW,lH,8); ctx.fill();
      ctx.strokeStyle='rgba(255,255,255,.07)'; ctx.lineWidth=1;
      ctx.beginPath(); ctx.roundRect(lX,lY,lW,lH,8); ctx.stroke();
      // Top gradient accent
      var topG=ctx.createLinearGradient(lX,lY,lX+lW,lY);
      topG.addColorStop(0,'rgba(0,153,214,.6)');
      topG.addColorStop(.5,'rgba(99,102,241,.4)');
      topG.addColorStop(1,'rgba(231,76,60,.6)');
      ctx.fillStyle=topG;
      ctx.beginPath(); ctx.roundRect(lX,lY,lW,3,[8,8,0,0]); ctx.fill();
      // Header
      ctx.font='bold 6.5px Inter,sans-serif';
      ctx.fillStyle='rgba(255,255,255,.35)';
      ctx.textAlign='left'; ctx.fillText('TRANSACTION LOG',lX+10,lY+16);
      // Live dot
      var dotPulse=.6+.4*Math.sin(fr*.12);
      ctx.fillStyle='rgba(62,188,121,'+dotPulse+')';
      ctx.beginPath(); ctx.arc(lX+lW-12,lY+12,3,0,Math.PI*2); ctx.fill();
      ctx.fillStyle='rgba(62,188,121,.2)';
      ctx.beginPath(); ctx.arc(lX+lW-12,lY+12,5.5,0,Math.PI*2); ctx.fill();

      // Transaction rows
      threatLog.slice(0,maxRows).forEach(function(t,i){
        var rowY=lY+24+i*rowH;
        var alpha=Math.min(.95,t.a);
        var isBlk=t.blocked;
        var rowCol=isBlk?'231,76,60':'62,188,121';
        var rowBg=isBlk?'rgba(60,8,8,.6)':'rgba(4,35,18,.6)';

        // Row card bg
        ctx.fillStyle=rowBg;
        ctx.beginPath(); ctx.roundRect(lX+6,rowY,lW-12,rowH-3,4); ctx.fill();

        // Left status stripe
        ctx.fillStyle='rgba('+rowCol+','+alpha*.8+')';
        ctx.beginPath(); ctx.roundRect(lX+6,rowY,3,rowH-3,[4,0,0,4]); ctx.fill();

        // Status icon circle
        ctx.fillStyle='rgba('+rowCol+','+alpha*.25+')';
        ctx.beginPath(); ctx.arc(lX+17,rowY+(rowH-3)/2,5.5,0,Math.PI*2); ctx.fill();
        ctx.strokeStyle='rgba('+rowCol+','+alpha*.6+')'; ctx.lineWidth=1;
        ctx.stroke();
        // ✓ or ✗ icon
        ctx.save(); ctx.translate(lX+17,rowY+(rowH-3)/2);
        ctx.strokeStyle='rgba('+rowCol+','+alpha+')'; ctx.lineWidth=1.5; ctx.lineCap='round'; ctx.lineJoin='round';
        if(isBlk){
          ctx.beginPath(); ctx.moveTo(-2.5,-2.5); ctx.lineTo(2.5,2.5); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(2.5,-2.5); ctx.lineTo(-2.5,2.5); ctx.stroke();
        } else {
          ctx.beginPath(); ctx.moveTo(-3,0); ctx.lineTo(-1,2.5); ctx.lineTo(3,-2.5); ctx.stroke();
        }
        ctx.restore();

        // Amount — prominent
        ctx.font='bold 8px Inter,sans-serif';
        ctx.fillStyle='rgba('+rowCol+','+Math.min(.95,alpha)+')';
        ctx.textAlign='left'; ctx.fillText(t.amt,lX+26,rowY+(rowH-3)/2+3);

        // Threat description
        var descX=lX+26+32;
        ctx.font='6px Inter,sans-serif';
        ctx.fillStyle='rgba(255,255,255,'+Math.min(.38,alpha*.4)+')';
        ctx.textAlign='left';
        // Truncate to fit
        var desc=t.txt;
        if(desc.length>20) desc=desc.substring(0,19)+'…';
        ctx.fillText(desc,descX,rowY+(rowH-3)/2+3);

        // Status pill right
        var pillW=isBlk?30:24, pillX=lX+lW-pillW-8;
        ctx.fillStyle='rgba('+rowCol+','+alpha*.18+')';
        ctx.beginPath(); ctx.roundRect(pillX,rowY+4,pillW,rowH-11,6); ctx.fill();
        ctx.strokeStyle='rgba('+rowCol+','+alpha*.4+')'; ctx.lineWidth=.8;
        ctx.beginPath(); ctx.roundRect(pillX,rowY+4,pillW,rowH-11,6); ctx.stroke();
        ctx.font='bold 5.5px Inter,sans-serif';
        ctx.fillStyle='rgba('+rowCol+','+Math.min(.9,alpha)+')';
        ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.fillText(isBlk?'BLOCKED':'PAID',pillX+pillW/2,rowY+(rowH-3)/2);
        ctx.textBaseline='alphabetic';

        t.a-=.0008;
      });
      ctx.textAlign='left';
    }

    // Backbone pipe
    var pY=H*.44, eX=W*.06, exX=W*.91;
    ctx.beginPath(); ctx.moveTo(eX,pY); ctx.lineTo(exX,pY);
    ctx.strokeStyle='rgba(0,0,0,.5)'; ctx.lineWidth=16; ctx.stroke();
    var pG=ctx.createLinearGradient(eX,0,exX,0);
    pG.addColorStop(0,'rgba(0,153,214,.25)'); pG.addColorStop(.5,'rgba(99,102,241,.3)'); pG.addColorStop(1,'rgba(62,188,121,.25)');
    ctx.strokeStyle=pG; ctx.lineWidth=12; ctx.stroke();
    ctx.strokeStyle='rgba(255,255,255,.06)'; ctx.lineWidth=2;
    ctx.beginPath(); ctx.moveTo(eX,pY-5); ctx.lineTo(exX,pY-5); ctx.stroke();

    // Flow inside pipe
    var fo=(-(fr*1.2))%32;
    for(var ox=fo;ox<exX-eX+32;ox+=32){
      ctx.fillStyle='rgba(0,200,255,.07)';
      ctx.beginPath(); ctx.rect(eX+ox,pY-5,22,10); ctx.fill();
    }

    // Shields
    var litSet={};
    pkts.forEach(function(p){
      for(var i=0;i<=p.shieldIdx&&i<SHIELDS.length;i++) litSet[i]=true;
    });
    SHIELDS.forEach(function(sh,i){
      var sx=W*sh.xF, sy=pY;
      var isActive=pkts.some(function(p){return p.phase==='travel'&&p.shieldIdx===i;});
      drawShield(sx,sy,sh.r,sh.col,isActive,!!litSet[i]);
      ctx.font='bold 8px Inter,sans-serif';
      ctx.fillStyle=litSet[i]?sh.col:'rgba(255,255,255,.2)';
      ctx.textAlign='center'; ctx.fillText(sh.label,sx,sy+sh.r+13);
      ctx.font='6.5px Inter,sans-serif'; ctx.fillStyle='rgba(255,255,255,.14)';
      ctx.fillText(sh.sub,sx,sy+sh.r+22);
      ctx.fillStyle=litSet[i]?sh.col+'28':'rgba(255,255,255,.04)';
      ctx.beginPath(); ctx.arc(sx-sh.r+2,sy-sh.r+2,8,0,Math.PI*2); ctx.fill();
      ctx.font='bold 7px Inter,sans-serif'; ctx.fillStyle=litSet[i]?sh.col:'rgba(255,255,255,.16)';
      ctx.textBaseline='middle'; ctx.fillText(i+1,sx-sh.r+2,sy-sh.r+2); ctx.textBaseline='alphabetic';
    });

    // Entry/exit nodes
    ctx.beginPath(); ctx.arc(eX,pY,15,0,Math.PI*2);
    ctx.fillStyle='rgba(0,200,255,.1)'; ctx.fill();
    ctx.strokeStyle='rgba(0,200,255,.35)'; ctx.lineWidth=1.5; ctx.stroke();
    ctx.font='bold 6.5px Inter,sans-serif'; ctx.fillStyle='rgba(0,200,255,.7)';
    ctx.textAlign='center'; ctx.fillText('IN',eX,pY+2.5);

    [[- 24,'PASS','rgba(62,188,121,.75)','rgba(62,188,121,.1)','rgba(62,188,121,.3)'],
     [+24,'BLOCK','rgba(231,76,60,.75)','rgba(231,76,60,.1)','rgba(231,76,60,.3)']
    ].forEach(function(row){
      var oy=row[0],lbl=row[1],tc=row[2],fc=row[3],sc=row[4];
      ctx.beginPath(); ctx.arc(exX,pY+oy,13,0,Math.PI*2);
      ctx.fillStyle=fc; ctx.fill(); ctx.strokeStyle=sc; ctx.lineWidth=1.5; ctx.stroke();
      ctx.font='bold 6px Inter,sans-serif'; ctx.fillStyle=tc;
      ctx.textAlign='center'; ctx.fillText(lbl,exX,pY+oy+2.5);
    });

    // Packets
    for(var pi=pkts.length-1;pi>=0;pi--){
      var p=pkts[pi];
      if(p.phase==='travel'){
        p.x+=p.vx;
        p.y+=p.wobble*Math.sin(fr*.07+pi);
        var sh=SHIELDS[p.shieldIdx];
        if(sh&&p.x>=W*sh.xF-sh.r-2){
          addFlash(W*sh.xF,pY,sh.col);
          if(p.blocked&&p.blockAt===p.shieldIdx){
            p.phase='explode'; addBurst(p.x,p.y);
          } else {
            p.shieldIdx++;
            if(p.shieldIdx>=SHIELDS.length) p.phase='pass';
          }
        }
        p.trail.push({x:p.x,y:p.y});
        if(p.trail.length>22) p.trail.shift();
        var isRed=p.blocked&&p.shieldIdx>=p.blockAt;
        var pCol=isRed?'231,76,60':'0,180,255';
        var pHex=isRed?'#E74C3C':'#00B4FF';
        var pGreen='62,188,121';

        // ── Comet tail ──
        p.trail.forEach(function(pt,ti){
          var ta=ti/p.trail.length;
          var r=Math.max(0.3, 5*ta*ta);
          ctx.beginPath(); ctx.arc(pt.x,pt.y,r,0,Math.PI*2);
          ctx.fillStyle='rgba('+pCol+','+(ta*.45)+')'; ctx.fill();
        });

        // ── Glow halo behind card ──
        var haloG=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,18);
        haloG.addColorStop(0,'rgba('+pCol+',.18)');
        haloG.addColorStop(1,'rgba('+pCol+',0)');
        ctx.beginPath(); ctx.arc(p.x,p.y,18,0,Math.PI*2);
        ctx.fillStyle=haloG; ctx.fill();

        // ── 3 alternating card styles ──
        ctx.shadowColor=pHex; ctx.shadowBlur=13;
        var st=p.style||0;

        if(st===0){
          // Style 0: Horizontal card
          var cw=54,ch=28,cx2=p.x-cw/2,cy2=p.y-ch/2;
          var cG=ctx.createLinearGradient(cx2,cy2,cx2+cw,cy2+ch);
          cG.addColorStop(0,isRed?'rgba(80,10,10,.92)':'rgba(0,25,55,.92)');
          cG.addColorStop(1,isRed?'rgba(50,5,5,.92)':'rgba(0,15,40,.92)');
          ctx.fillStyle=cG; ctx.beginPath(); ctx.roundRect(cx2,cy2,cw,ch,6); ctx.fill();
          ctx.shadowBlur=0;
          ctx.strokeStyle='rgba('+pCol+',.65)'; ctx.lineWidth=1.2;
          ctx.beginPath(); ctx.roundRect(cx2,cy2,cw,ch,6); ctx.stroke();
          ctx.fillStyle='rgba('+pCol+',.7)';
          ctx.beginPath(); ctx.roundRect(cx2,cy2,cw,3,[6,6,0,0]); ctx.fill();
          var ix=cx2+9,iy=p.y;
          ctx.strokeStyle='rgba('+pCol+',.9)'; ctx.lineWidth=1.5; ctx.lineCap='round'; ctx.lineJoin='round';
          ctx.beginPath(); ctx.moveTo(ix-4,iy); ctx.lineTo(ix+4,iy); ctx.stroke();
          ctx.beginPath(); ctx.moveTo(ix+1,iy-3); ctx.lineTo(ix+4,iy); ctx.lineTo(ix+1,iy+3); ctx.stroke();
          ctx.font='bold 8px Inter,sans-serif';
          ctx.fillStyle=isRed?'rgba(255,140,130,.95)':'rgba(0,230,255,.95)';
          ctx.textAlign='center'; ctx.textBaseline='middle';
          ctx.fillText(p.amt,cx2+cw*.62,p.y+1); ctx.textBaseline='alphabetic';
          ctx.font='5px Inter,sans-serif'; ctx.fillStyle='rgba(255,255,255,.28)';
          ctx.textAlign='left'; ctx.fillText('UPI',cx2+4,cy2+ch-4);

        } else if(st===1){
          // Style 1: Tall vertical badge
          var bw=28,bh=36,bx2=p.x-bw/2,by2=p.y-bh/2;
          ctx.fillStyle=isRed?'rgba(60,5,5,.94)':'rgba(0,20,50,.94)';
          ctx.beginPath(); ctx.roundRect(bx2,by2,bw,bh,5); ctx.fill();
          ctx.shadowBlur=0;
          ctx.strokeStyle='rgba('+pCol+',.6)'; ctx.lineWidth=1;
          ctx.beginPath(); ctx.roundRect(bx2,by2,bw,bh,5); ctx.stroke();
          ctx.fillStyle='rgba('+pCol+',.8)';
          ctx.beginPath(); ctx.roundRect(bx2,by2,3,bh,[5,0,0,5]); ctx.fill();
          ctx.font='bold 10px Inter,sans-serif';
          ctx.fillStyle='rgba('+pCol+',.9)'; ctx.textAlign='center'; ctx.textBaseline='middle';
          ctx.fillText('₹',p.x+1,by2+11);
          ctx.strokeStyle='rgba('+pCol+',.2)'; ctx.lineWidth=.8;
          ctx.beginPath(); ctx.moveTo(bx2+5,by2+18); ctx.lineTo(bx2+bw-5,by2+18); ctx.stroke();
          ctx.font='bold 6px Inter,sans-serif';
          ctx.fillStyle=isRed?'rgba(255,160,140,.9)':'rgba(100,230,255,.9)';
          var sa=p.amt.replace('₹','').replace(/,/g,'');
          if(sa.length>5) sa=sa.substring(0,4)+'…';
          ctx.fillText(sa,p.x+1,by2+27); ctx.textBaseline='alphabetic';
          ctx.fillStyle='rgba('+pCol+',.7)';
          ctx.beginPath(); ctx.arc(p.x,by2+bh-5,2.5,0,Math.PI*2); ctx.fill();

        } else {
          // Style 2: Rounded pill
          var pw=58,ph=22,px4=p.x-pw/2,py4=p.y-ph/2;
          var pG2=ctx.createLinearGradient(px4,py4,px4+pw,py4+ph);
          pG2.addColorStop(0,isRed?'rgba(90,12,12,.9)':'rgba(0,30,65,.9)');
          pG2.addColorStop(1,isRed?'rgba(40,4,4,.9)':'rgba(0,12,35,.9)');
          ctx.fillStyle=pG2; ctx.beginPath(); ctx.roundRect(px4,py4,pw,ph,ph/2); ctx.fill();
          ctx.shadowBlur=0;
          ctx.strokeStyle='rgba('+pCol+',.6)'; ctx.lineWidth=1;
          ctx.beginPath(); ctx.roundRect(px4,py4,pw,ph,ph/2); ctx.stroke();
          ctx.fillStyle='rgba('+pCol+',.9)';
          ctx.beginPath(); ctx.arc(px4+10,p.y,4,0,Math.PI*2); ctx.fill();
          ctx.fillStyle='rgba(255,255,255,.6)';
          ctx.beginPath(); ctx.arc(px4+10,p.y,1.8,0,Math.PI*2); ctx.fill();
          ctx.font='bold 7.5px Inter,sans-serif';
          ctx.fillStyle=isRed?'rgba(255,150,130,.95)':'rgba(0,220,255,.95)';
          ctx.textAlign='center'; ctx.textBaseline='middle';
          ctx.fillText(p.amt,px4+pw*.6,p.y); ctx.textBaseline='alphabetic';
        }
        if(p.x>W+20) pkts.splice(pi,1);

      } else if(p.phase==='explode'){
        p.exR+=3; p.exA-=.025;
        if(p.exA<=0){pkts.splice(pi,1); continue;}
        ctx.beginPath(); ctx.arc(p.x,p.y,p.exR,0,Math.PI*2);
        ctx.strokeStyle='rgba(231,76,60,'+p.exA*.6+')'; ctx.lineWidth=2.5; ctx.stroke();
        ctx.font='bold 8px Inter,sans-serif'; ctx.fillStyle='rgba(231,76,60,'+p.exA+')';
        ctx.textAlign='center'; ctx.fillText('BLOCKED',p.x,p.y-p.exR-5);

      } else if(p.phase==='pass'){
        p.x+=p.vx*1.3;
        p.trail.push({x:p.x,y:p.y});
        if(p.trail.length>22) p.trail.shift();

        // Comet tail — green
        p.trail.forEach(function(pt,ti){
          var ta=ti/p.trail.length;
          ctx.beginPath(); ctx.arc(pt.x,pt.y,Math.max(.3,5*ta*ta),0,Math.PI*2);
          ctx.fillStyle='rgba(62,188,121,'+ta*.45+')'; ctx.fill();
        });

        // Glow halo
        var haloG=ctx.createRadialGradient(p.x,p.y,0,p.x,p.y,18);
        haloG.addColorStop(0,'rgba(62,188,121,.2)');
        haloG.addColorStop(1,'rgba(62,188,121,0)');
        ctx.beginPath(); ctx.arc(p.x,p.y,18,0,Math.PI*2);
        ctx.fillStyle=haloG; ctx.fill();

        // Approved card
        var cw=54, ch=28, cx2=p.x-cw/2, cy2=p.y-ch/2;
        ctx.shadowColor='#3EBC79'; ctx.shadowBlur=14;
        var cardG=ctx.createLinearGradient(cx2,cy2,cx2+cw,cy2+ch);
        cardG.addColorStop(0,'rgba(0,40,20,.92)');
        cardG.addColorStop(1,'rgba(0,25,12,.92)');
        ctx.fillStyle=cardG;
        ctx.beginPath(); ctx.roundRect(cx2,cy2,cw,ch,6); ctx.fill();
        ctx.shadowBlur=0;
        // border
        ctx.strokeStyle='rgba(62,188,121,.65)'; ctx.lineWidth=1.2;
        ctx.beginPath(); ctx.roundRect(cx2,cy2,cw,ch,6); ctx.stroke();
        // top accent stripe — green
        ctx.fillStyle='rgba(62,188,121,.75)';
        ctx.beginPath(); ctx.roundRect(cx2,cy2,cw,3,[6,6,0,0]); ctx.fill();
        // checkmark icon left
        var ix=cx2+9, iy=p.y+1;
        ctx.strokeStyle='rgba(62,188,121,.95)'; ctx.lineWidth=1.8; ctx.lineCap='round'; ctx.lineJoin='round';
        ctx.beginPath(); ctx.moveTo(ix-4,iy); ctx.lineTo(ix-1,iy+3); ctx.lineTo(ix+4,iy-3); ctx.stroke();
        // amount text
        ctx.font='bold 8px Inter,sans-serif';
        ctx.fillStyle='rgba(100,255,180,.95)';
        ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.fillText(p.amt,cx2+cw*.62,p.y+1);
        ctx.textBaseline='alphabetic';
        // tiny PAID label
        ctx.font='5px Inter,sans-serif';
        ctx.fillStyle='rgba(62,188,121,.5)';
        ctx.textAlign='left';
        ctx.fillText('PAID',cx2+4,cy2+ch-4);

        if(p.x>W+20) pkts.splice(pi,1);
      }
    }

    // Burst particles
    for(var bi=bursts.length-1;bi>=0;bi--){
      var b=bursts[bi];
      if(b.ring){
        b.r+=b.vr; b.a-=.03;
        ctx.beginPath(); ctx.arc(b.x,b.y,b.r,0,Math.PI*2);
        ctx.strokeStyle='rgba(231,76,60,'+b.a+')'; ctx.lineWidth=2; ctx.stroke();
      } else {
        ctx.beginPath(); ctx.arc(b.x,b.y,b.r*b.a,0,Math.PI*2);
        ctx.fillStyle='rgba(231,76,60,'+b.a+')'; ctx.fill();
        b.x+=b.vx; b.y+=b.vy; b.vy+=.1; b.a-=.03;
      }
      if(b.a<=0) bursts.splice(bi,1);
    }

    // Flash effects
    for(var fi=flashes.length-1;fi>=0;fi--){
      var f=flashes[fi]; f.r+=8; f.a-=.07;
      if(f.r>1&&f.a>0){
        var fg=ctx.createRadialGradient(f.x,f.y,0,f.x,f.y,f.r);
        fg.addColorStop(0,f.col+'44'); fg.addColorStop(1,f.col+'00');
        ctx.beginPath(); ctx.arc(f.x,f.y,f.r,0,Math.PI*2); ctx.fillStyle=fg; ctx.fill();
      }
      if(f.a<=0) flashes.splice(fi,1);
    }

    // Radar
    var rX=W*.13, rY=H*.77, rR=Math.max(Math.min(W*.09,H*.13),20);
    var rBg=ctx.createRadialGradient(rX,rY,0,rX,rY,rR);
    rBg.addColorStop(0,'rgba(99,102,241,.12)'); rBg.addColorStop(1,'rgba(99,102,241,0)');
    ctx.beginPath(); ctx.arc(rX,rY,rR,0,Math.PI*2); ctx.fillStyle=rBg; ctx.fill();
    [1,.66,.33].forEach(function(m){
      ctx.beginPath(); ctx.arc(rX,rY,rR*m,0,Math.PI*2);
      ctx.strokeStyle='rgba(99,102,241,.15)'; ctx.lineWidth=1; ctx.stroke();
    });
    ctx.strokeStyle='rgba(99,102,241,.1)'; ctx.lineWidth=1;
    ctx.beginPath(); ctx.moveTo(rX-rR,rY); ctx.lineTo(rX+rR,rY); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(rX,rY-rR); ctx.lineTo(rX,rY+rR); ctx.stroke();
    var swA=(fr*.025)%(Math.PI*2);
    ctx.save(); ctx.translate(rX,rY);
    for(var sa=0;sa<18;sa++){
      var ang=swA-sa*.03, al=Math.max(0,(18-sa)/18*.3);
      ctx.beginPath(); ctx.moveTo(0,0);
      ctx.arc(0,0,rR,ang-.03,ang+.005); ctx.closePath();
      ctx.fillStyle='rgba(62,188,121,'+al+')'; ctx.fill();
    }
    ctx.restore();
    ctx.beginPath(); ctx.moveTo(rX,rY);
    ctx.lineTo(rX+Math.cos(swA)*rR,rY+Math.sin(swA)*rR);
    ctx.strokeStyle='rgba(62,188,121,.7)'; ctx.lineWidth=1.5; ctx.stroke();
    radarDots.forEach(function(d){
      d.age++;
      var da=Math.max(0,1-d.age/120);
      var rx2=rX+Math.cos(d.a)*d.d*rR, ry2=rY+Math.sin(d.a)*d.d*rR;
      ctx.beginPath(); ctx.arc(rx2,ry2,d.hot?3.5:2,0,Math.PI*2);
      ctx.fillStyle='rgba('+(d.hot?'231,76,60':'62,188,121')+','+da+')'; ctx.fill();
    });
    ctx.font='bold 6.5px Inter,sans-serif'; ctx.fillStyle='rgba(99,102,241,.4)';
    ctx.textAlign='center'; ctx.fillText('THREAT RADAR',rX,rY+rR+12);

    // Stats panel
    var stX=W*.3, stY=H*.72, stW=W*.66, stH=H*.24;
    ctx.fillStyle='rgba(0,0,0,.4)';
    ctx.beginPath(); ctx.rect(stX,stY,stW,stH); ctx.fill();
    ctx.strokeStyle='rgba(99,102,241,.12)'; ctx.lineWidth=1;
    ctx.beginPath(); ctx.rect(stX,stY,stW,stH); ctx.stroke();
    ctx.font='bold 6.5px Inter,sans-serif'; ctx.fillStyle='rgba(255,255,255,.18)';
    ctx.textAlign='left'; ctx.fillText('REAL-TIME METRICS',stX+10,stY+13);
    var stats=[
      {l:'Blocked Today',v:fraudCount.toLocaleString('en-IN'),c:'#E74C3C'},
      {l:'Accuracy',v:'99.7%',c:'#3EBC79'},
      {l:'Avg latency',v:'8ms',c:'#FFCE00'},
      {l:'Checked/min',v:(Math.floor(Math.random()*200+800)).toLocaleString(),c:'#0099D6'},
    ];
    var sbw=(stW-20)/2-8, sbh=(stH-24)/2-6;
    if(sbw>10&&sbh>8){
      stats.forEach(function(st,i){
        var bx=stX+10+(i%2)*(sbw+16), by=stY+20+Math.floor(i/2)*(sbh+8);
        ctx.fillStyle='rgba(255,255,255,.03)';
        ctx.beginPath(); ctx.rect(bx,by,sbw,sbh); ctx.fill();
        ctx.strokeStyle=st.c+'22'; ctx.lineWidth=1;
        ctx.beginPath(); ctx.rect(bx,by,sbw,sbh); ctx.stroke();
        ctx.font='bold '+Math.max(8,Math.floor(sbh*.38))+'px Inter,sans-serif';
        ctx.fillStyle=st.c; ctx.textAlign='left'; ctx.fillText(st.v,bx+7,by+sbh*.62);
        ctx.font=Math.max(6,Math.floor(sbh*.26))+'px Inter,sans-serif';
        ctx.fillStyle='rgba(255,255,255,.28)'; ctx.fillText(st.l,bx+7,by+sbh*.88);
      });
    }

    ctx.textAlign='left'; ctx.textBaseline='alphabetic';
    fr++;
    var ns=Math.floor((fr%(STEPS*SDUR))/SDUR);
    if(ns!==step){
      step=ns;
      sEls.forEach(function(el,i){
        el.classList.toggle('active',i===step);
        el.classList.toggle('done',i<step);
      });
    }
    requestAnimationFrame(draw);
  }
  draw();
})();



/* ── ACTIVE NAV + PROGRESS DOTS ── */
const sections = ['hero','solutions','hiw','videos','industries','why','testimonials','assist'];
const dots = document.querySelectorAll('.pdot');
const navAs = document.querySelectorAll('.nav-links a');

function updateActive() {
  let current = 'hero';
  sections.forEach(id => {
    const el = document.getElementById(id) || document.getElementById(id === 'solutions' ? 'sol1' : id);
    if (el && scrollY >= el.offsetTop - 120) current = id;
  });
  dots.forEach((d, i) => d.classList.toggle('active', sections[i] === current));
  navAs.forEach(a => {
    const sec = a.dataset.section || '';
    a.classList.toggle('active', sec === current || (current === 'solutions' && sec === 'sol1'));
  });
}
window.addEventListener('scroll', updateActive, {passive:true});
dots.forEach((d, i) => {
  d.addEventListener('click', () => {
    const target = document.getElementById(sections[i]) || document.getElementById('sol1');
    if (target) target.scrollIntoView({behavior:'smooth'});
  });
});

/* ── CANVAS HELPERS ── */
function mkC(id) {
  const c = document.getElementById(id), ctx = c.getContext('2d');
  function resize() {
    const w = c.offsetWidth || (c.parentElement && c.parentElement.offsetWidth) || 600, h = c.offsetHeight || 480;
    c.width = w * devicePixelRatio;
    c.height = h * devicePixelRatio;
    ctx.setTransform(devicePixelRatio,0,0,devicePixelRatio,0,0);
  }
  resize(); window.addEventListener('resize', resize);
  return { c, ctx, W: () => c.offsetWidth || 600, H: () => c.offsetHeight || 480 };
}

/* ── SKELETON REMOVE AFTER FIRST FRAME ── */
function clearSkeleton(id) { setTimeout(() => { const s = document.getElementById(id); if(s) s.classList.add('done'); }, 600); }

/* ══ CANVAS 1 — NODE GRAPH ══ */
(function(){
  const {c,ctx,W,H} = mkC('routeCanvas');
  clearSkeleton('sk1');
  const nodes = [
    {label:'YOUR\\nAPP',   x:.13,y:.5,  col:'#1A2B6B',r:26},
    {label:'UPI\\nSWITCH', x:.5, y:.5,  col:'#0099D6',r:34,big:true},
    {label:'HDFC',        x:.87,y:.2,  col:'#0099D6',r:22},
    {label:'ICICI',       x:.87,y:.5,  col:'#1A2B6B',r:22},
    {label:'SBI',         x:.87,y:.8,  col:'#3EBC79',r:22},
  ];
  const edges = [{a:0,b:1},{a:1,b:2},{a:1,b:3},{a:1,b:4}];
  const pkts = [];
  setInterval(() => { const e = edges[Math.floor(Math.random()*edges.length)]; pkts.push({a:e.a,b:e.b,t:0,sp:.011+Math.random()*.011,col:nodes[e.b].col}); }, 380);
  let tick = 0;
  function draw() {
    ctx.clearRect(0,0,W(),H()); ctx.fillStyle='#D8F0FA'; ctx.fillRect(0,0,W(),H());
    edges.forEach(e => {
      const a=nodes[e.a],b=nodes[e.b];
      ctx.beginPath(); ctx.setLineDash([6,9]); ctx.strokeStyle='rgba(0,153,214,.25)'; ctx.lineWidth=1.5;
      ctx.moveTo(a.x*W(),a.y*H()); ctx.lineTo(b.x*W(),b.y*H()); ctx.stroke(); ctx.setLineDash([]);
    });
    for(let i=pkts.length-1;i>=0;i--){
      const p=pkts[i],a=nodes[p.a],b=nodes[p.b];
      const x=a.x*W()+(b.x*W()-a.x*W())*p.t, y=a.y*H()+(b.y*H()-a.y*H())*p.t;
      ctx.beginPath(); ctx.arc(x,y,5,0,Math.PI*2); ctx.fillStyle=p.col;
      ctx.shadowColor=p.col; ctx.shadowBlur=14; ctx.fill(); ctx.shadowBlur=0;
      p.t+=p.sp; if(p.t>=1) pkts.splice(i,1);
    }
    nodes.forEach(n => {
      const x=n.x*W(), y=n.y*H(), pulse=.72+.28*Math.sin(tick*.05+n.x*8);
      const g=ctx.createRadialGradient(x,y,0,x,y,n.r*2.2*pulse);
      g.addColorStop(0,n.col+'30'); g.addColorStop(1,n.col+'00');
      ctx.beginPath(); ctx.arc(x,y,n.r*2.2*pulse,0,Math.PI*2); ctx.fillStyle=g; ctx.fill();
      ctx.beginPath(); ctx.arc(x,y,n.r,0,Math.PI*2); ctx.fillStyle='#fff'; ctx.fill();
      ctx.strokeStyle=n.col; ctx.lineWidth=2.5; ctx.stroke();
      ctx.fillStyle=n.col; ctx.font=\`bold \${n.big?10:8}px Nunito,sans-serif\`;
      ctx.textAlign='center'; ctx.textBaseline='middle';
      n.label.split('\\n').forEach((l,i,a) => ctx.fillText(l,x,y+(i-(a.length-1)/2)*11));
    });
    ctx.textAlign='left'; ctx.textBaseline='alphabetic';
    tick++; requestAnimationFrame(draw);
  }
  draw();
})();

/* ══ CANVAS 2 — MATRIX RAIN ══ */
(function(){
  const {c,ctx,W,H} = mkC('fraudCanvas');
  clearSkeleton('sk2');
  const FS=14; let cols,drops;
  function init(){ cols=Math.floor(W()/FS); drops=Array.from({length:cols},()=>Math.random()*H()/FS*-1); }
  init(); window.addEventListener('resize',init);
  const chars='₹UPIBLOCKED✗SECURE018ABCDEF'.split('');
  function draw(){
    ctx.fillStyle='rgba(10,18,48,.18)'; ctx.fillRect(0,0,W(),H());
    drops.forEach((y,i) => {
      const ch=chars[Math.floor(Math.random()*chars.length)];
      ctx.font=FS+'px monospace';
      ctx.fillStyle=Math.random()>.93?'#fff':\`rgba(0,153,214,\${.25+Math.random()*.45})\`;
      ctx.fillText(ch,i*FS,y*FS);
      drops[i]=(y*FS>H()&&Math.random()>.97)?-5:y+1;
    });
    requestAnimationFrame(draw);
  }
  draw();
})();

/* ══ CANVAS 3 — LIVE CHART ══ */
(function(){
  const {c,ctx,W,H} = mkC('chartCanvas');
  clearSkeleton('sk3');
  const MAX=70;
  const series=[
    {label:'Success %',col:'#0099D6',base:.942,w:.03,data:[]},
    {label:'Volume',   col:'#1A2B6B',base:.65, w:.07,data:[]},
    {label:'Fraud',    col:'#3EBC79',base:.05, w:.02,data:[]},
  ];
  series.forEach(s => { for(let i=0;i<MAX;i++) s.data.push(s.base); });
  let t=0;
  function draw(){
    ctx.clearRect(0,0,W(),H()); ctx.fillStyle='#D9F5E9'; ctx.fillRect(0,0,W(),H());
    const pL=10,pR=10,pT=20,pB=40,gW=W()-pL-pR,gH=H()-pT-pB;
    ctx.setLineDash([3,6]);
    for(let i=1;i<=3;i++){ const y=pT+i*(gH/4); ctx.beginPath(); ctx.strokeStyle='rgba(0,0,0,.07)'; ctx.lineWidth=1; ctx.moveTo(pL,y); ctx.lineTo(W()-pR,y); ctx.stroke(); }
    ctx.setLineDash([]);
    series.forEach(s => {
      const v=s.base+Math.sin(t*.038+s.w*15)*s.w+(Math.random()-.5)*s.w*.3;
      s.data.push(Math.max(.01,Math.min(.99,v))); if(s.data.length>MAX) s.data.shift();
      const r=parseInt(s.col.slice(1,3),16),g=parseInt(s.col.slice(3,5),16),b=parseInt(s.col.slice(5,7),16);
      const gr=ctx.createLinearGradient(0,pT,0,pT+gH);
      gr.addColorStop(0,\`rgba(\${r},\${g},\${b},.16)\`); gr.addColorStop(1,\`rgba(\${r},\${g},\${b},0)\`);
      ctx.beginPath(); s.data.forEach((val,i)=>{ const x=pL+i*(gW/(MAX-1)),y=pT+gH-val*gH; if(i===0)ctx.moveTo(x,y);else ctx.lineTo(x,y); });
      ctx.lineTo(pL+gW,pT+gH); ctx.lineTo(pL,pT+gH); ctx.closePath(); ctx.fillStyle=gr; ctx.fill();
      ctx.beginPath(); s.data.forEach((val,i)=>{ const x=pL+i*(gW/(MAX-1)),y=pT+gH-val*gH; if(i===0)ctx.moveTo(x,y);else ctx.lineTo(x,y); });
      ctx.strokeStyle=s.col; ctx.lineWidth=2; ctx.lineJoin='round'; ctx.stroke();
      const lx=pL+gW,ly=pT+gH-s.data[s.data.length-1]*gH;
      ctx.beginPath(); ctx.arc(lx,ly,4,0,Math.PI*2); ctx.fillStyle=s.col; ctx.fill();
    });
    series.forEach((s,i)=>{ ctx.fillStyle=s.col; ctx.fillRect(pL+i*100,H()-22,12,3); ctx.fillStyle='rgba(0,0,0,.45)'; ctx.font='bold 9px Nunito Sans'; ctx.textAlign='left'; ctx.fillText(s.label,pL+i*100+16,H()-14); });
    t++; requestAnimationFrame(draw);
  }
  draw();
})();

/* ══ CANVAS 4 — SCALE BARS ══ */
(function(){
  const {c,ctx,W,H} = mkC('scaleCanvas');
  clearSkeleton('sk4');
  const N=12;
  const bars=Array.from({length:N},(_,i)=>({h:.2+Math.random()*.6,th:.2+Math.random()*.65,sp:.012+Math.random()*.008,col:i%2===0?'#0099D6':'#1A2B6B'}));
  setInterval(()=>{ bars[Math.floor(Math.random()*N)].th=.88+Math.random()*.1; },1200);
  const labels=['1x','2x','4x','8x','16x','32x'];
  function draw(){
    ctx.clearRect(0,0,W(),H()); ctx.fillStyle='#E8EEF8'; ctx.fillRect(0,0,W(),H());
    const pad=20,gap=7,bw=(W()-pad*2-gap*(N-1))/N;
    bars.forEach((b,i)=>{
      b.h+=(b.th-b.h)*b.sp; if(Math.abs(b.h-b.th)<.003) b.th=.2+Math.random()*.65;
      const x=pad+i*(bw+gap),bh=b.h*(H()-pad*2-20),y=H()-pad-20-bh;
      const gr=ctx.createLinearGradient(0,y,0,H()-pad-20);
      gr.addColorStop(0,b.col); gr.addColorStop(1,b.col+'44');
      ctx.beginPath(); ctx.roundRect(x,y,bw,bh,4); ctx.fillStyle=gr; ctx.fill();
      if(b.h>.3){ ctx.fillStyle='rgba(255,255,255,.85)'; ctx.font='bold 9px Nunito'; ctx.textAlign='center'; ctx.fillText(Math.round(b.h*100)+'%',x+bw/2,y+13); }
    });
    ctx.fillStyle='rgba(26,43,107,.4)'; ctx.font='9px Nunito Sans'; ctx.textAlign='center';
    labels.forEach((l,i)=>{ if(i<N) ctx.fillText(l,pad+i*(bw+gap)+bw/2,H()-8); });
    ctx.textAlign='left'; requestAnimationFrame(draw);
  }
  draw();
})();

/* ══ FOOTER CANVAS — floating network particles ══ */
(function(){
  const c = document.getElementById('footerCanvas');
  if (!c) return;
  const ctx = c.getContext('2d');
  function resize() {
    const _fw=c.offsetWidth||600, _fh=c.offsetHeight||400;
    c.width = _fw * devicePixelRatio;
    c.height = _fh * devicePixelRatio;
    ctx.setTransform(devicePixelRatio,0,0,devicePixelRatio,0,0);
  }
  resize(); window.addEventListener('resize', resize);
  const W = () => c.offsetWidth, H = () => c.offsetHeight;
  const N = 60;
  const pts = Array.from({length: N}, () => ({
    x: Math.random() * W(), y: Math.random() * H(),
    vx: (Math.random() - 0.5) * 0.3, vy: (Math.random() - 0.5) * 0.3,
    r: Math.random() * 1.5 + 0.5,
    col: Math.random() > 0.6 ? '0,153,214' : Math.random() > 0.5 ? '62,188,121' : '255,255,255'
  }));
  function draw() {
    ctx.clearRect(0, 0, W(), H());
    for (let i = 0; i < N; i++) {
      for (let j = i + 1; j < N; j++) {
        const dx = pts[i].x - pts[j].x, dy = pts[i].y - pts[j].y;
        const d = Math.sqrt(dx*dx + dy*dy);
        if (d < 100) {
          ctx.beginPath();
          ctx.strokeStyle = \`rgba(0,153,214,\${(1 - d/100) * 0.12})\`;
          ctx.lineWidth = 0.8;
          ctx.moveTo(pts[i].x, pts[i].y);
          ctx.lineTo(pts[j].x, pts[j].y);
          ctx.stroke();
        }
      }
    }
    pts.forEach(p => {
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = \`rgba(\${p.col},0.35)\`;
      ctx.fill();
      p.x += p.vx; p.y += p.vy;
      if (p.x < 0 || p.x > W()) p.vx *= -1;
      if (p.y < 0 || p.y > H()) p.vy *= -1;
    });
    requestAnimationFrame(draw);
  }
  draw();
})();

`;
